import {
  canShowBySuppressionKey,
  suppressBySuppressionKey,
} from '../../../shared/services/localStorageSuppression';

const FOLLOW_COMPLETION_PROMPT_KEY = 'followCompletionPromptSuppressedUntil';

export const DEFAULT_SUPPRESSION_DAYS = 14;

export const canShowFollowCompletionPrompt = (
  now: Date = new Date(),
): boolean => canShowBySuppressionKey(FOLLOW_COMPLETION_PROMPT_KEY, now);

export const suppressFollowCompletionPrompt = (
  days: number = DEFAULT_SUPPRESSION_DAYS,
  now: Date = new Date(),
): void => suppressBySuppressionKey(FOLLOW_COMPLETION_PROMPT_KEY, days, now);

export const suppressFollowCompletionPromptIfChecked = (
  checked: boolean,
): void => {
  if (!checked) {
    return;
  }
  suppressFollowCompletionPrompt();
};
